import { useContext, useEffect, useState } from "react";
import {getEntities, getEntityTypes, getUserRoleTypes} from "../helpers/tableauUserHelpers";


import lockImg from "../content/img/lock.png";
import unLockImg from "../content/img/unlock.png";

import 'react-tabs/style/react-tabs.css';
import '../content/ccbh-tableau-portal_2.0.css';
import { formatAsPhone, formatPhone } from "../scripts/ccbh";
import { ccbhmessagebox, removeMsg } from "../scripts/ccbh.ui";
import '../content/ccbh.ui.css';

const EmployeeAccountViewPanel = (user) => {
    const [lockImageStateIndex, setLockImageStateIndex] = useState(0);
    const imgList = [lockImg, unLockImg];
    
    const [selectedEmployee, setSelectedEmployee] = useState('');
    const [selectedEmployeeFullName, setSelectedEmployeeFullName] = useState('');
    const [selectedEmployeeEntity, setSelectedEmployeeEntity] = useState(user.tableauEntities[0].id);
    const [selectEmployeeEntityType, setSelectedEmployeeEntityType] = useState(user.tableauEntities[0].type);
    const [selectedEmployeeManagerName, setSelectedEmployeeManagerName] = useState(user.lastName + ", " + user.firstName)
    const [entitiesList, setEntitiesList] = useState('');
    const [entityTypeList, setEntityTypeList] = useState('');
    const [buttonRowDisabled, setButtonRowDisabled] = useState(true);
    
    const [entityOptions, setEntityOptions] = useState('');
    const [entityTypeOptions, setEntityTypeOptions] = useState('');
    
    const fetchEntities = async() => {
        return await getEntities(user.authorization);    //user.tableauEntities;
    }

    const fetchEntityTypes = async() =>{
        return await getEntityTypes(user.authorization);
    }

    const fetchUserRoleTypes = async() => {
        return await getUserRoleTypes(user.authorization);
    }


    const flipDisableReadOnly = (elem) => {
        if (elem.disabled) {
            elem.removeAttribute("disabled");
            setLockImageStateIndex(1);
        } else {
            elem.setAttribute("disabled", "true");
            setLockImageStateIndex(0);
            setButtonRowDisabled(true);
        }
    }

    const getEmployeeInformation = (employeeWebuserId) => {
        console.log("Double Click");
        const employee = user.directReportEmployees.find((emp) =>{
            if(emp.webuserId === employeeWebuserId){
                return emp;
            }
        });

        setSelectedEmployee(employee);
        setSelectedEmployeeFullName(employee.lastName + ", " + employee.firstName);

        var selectRole = document.getElementById('role_code');
        for (var idx = 0; idx < selectRole.options.length; idx++) {
            if (selectRole.options[idx].innerText.trim() === selectedEmployee.title) {
                selectRole.selectedIndex = idx;
                break;
            }
        }

    }

    const editEmployeesView = () => {
        flipDisableReadOnly(document.getElementById('newuser-firstname'));
        flipDisableReadOnly(document.getElementById('newuser-lastname'));
        flipDisableReadOnly(document.getElementById('newuser-email'));
        flipDisableReadOnly(document.getElementById('newuser-phone'));
    }
    
    const enableAddUser = () =>{
        console.log('Enable Add User');
        setButtonRowDisabled(false);
    }

    const setEntityType = () => {
        console.log('Set Entity Type');
    }

    const setSelecteddefaultValue  = () => {
        console.log('Set selected default Value');
    }    

    const entityListOption = (type, id, name, isSelected) =>{
        const value = type + ":" + id + ":" + name;
        var selected='';
        if(isSelected){
            selected = "selected";
        }
        
        return (
            <option value={value} selected={selected}>{name}</option>
        )
    }

    const entityTypeListOption = (id, name, isSelected) => {
        var selected='';
        if(isSelected){
            selected = "selected";
        }
        
        return(
            <option value={id} selected={selected} >{name}</option>
        )
    }

    const [roleTypes, setRoleTypes] = useState('');
    const [roleTypeOption, setRoleTypesOptions] = useState('');
    const roleTypeListOption = (id, name, isSelected) => {
        var selected='';
        if(isSelected){
            selected="selected";
        }
        return(
            <option value={id} selected={selected} >{name}</option>
        )
    }


    useEffect(() =>{
        fetchEntities().then((nts) =>{
            setEntitiesList(nts);
            console.log('fetch entities', nts);
            setEntityOptions(nts.map((n) => entityListOption(n.type, n.id, n.name, (n.id === selectedEmployeeEntity) )));
        });

        fetchEntityTypes().then((et) => {
            setEntityTypeList(et);
            console.log('fetch entity types', et);
            setEntityTypeOptions(et.map((e) => entityTypeListOption(e.id, e.name, (e.id === selectEmployeeEntityType) )));
        });
        
        fetchUserRoleTypes().then((rs) =>{
            setRoleTypes(rs);
            setRoleTypesOptions(rs.map((r) => roleTypeListOption(r.id, r.name, (r.name === selectedEmployee.title))));
        });

    }, [2]);




    return (
        <>
            <div id="admin-action-message">
                <label id="admin-message" className="warning2">This is a message</label>
            </div>
            <input type="hidden" id="add-supervisor-id" name="supervisor-id" defaultValue="@user.Username" />
            <input type="hidden" id="entity-id" name="entity-id" defaultValue="@user.Entites[0].Id" />
            <input type="hidden" id="disable" name="disable" defaultValue="" />

            <div className="shadow-panel-med" id="add-user-panel">
                <div className="shadow-title">
                    <h2 className="shadow-title-edit-employee">Add/Edit User Account</h2>
                    <img className="selectable-img" id="add-delegates" src={imgList[lockImageStateIndex]} onClick={() => {editEmployeesView(this)}} title="Edit Employee Account Information" disable />
                </div>
            
                <div className="shadow-talk">
                    <div className="lbl-wrap-x-more">
                        <input type="text" id="newuser-firstname" name="newuser-firstname" defaultValue={selectedEmployee.firstName} onChange={enableAddUser} required disabled />
                        <label for="firstname">first name</label>
                    </div>

                    <div className="lbl-wrap-x-more">
                        <input type="text" id="newuser-lastname" name="newuser-lastname" defaultValue={selectedEmployee.lastName} onChange={enableAddUser} required disabled />
                        <label for="lastname">last name</label>
                    </div>

                    <div className="lbl-wrap-x-more">
                        <input type="tel" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" required id="newuser-phone" name="newuser-phone" title="Format:123-456-7890" x-moz-errormessage="Format:123-456-7890" defaultValue={selectedEmployee.phoneNumber} onChange={() => {formatAsPhone(this); enableAddUser();}} disabled />
                        <label for="phone_number">Phone Number</label>
                    </div>

                    <div className="lbl-wrap-x-more">
                        <label for="email">
                        <input type="email" id="newuser-email" name="newuser-email" defaultValue={selectedEmployee.email} title="Enter a valid email address" x-moz-errormessage="Please enter a valid email address" onChange={enableAddUser} required disabled />
                        Email</label>
                    </div>

                    <div className="lbl-wrap-x-more">
                        <input type="text" id="last-login-date" name="last-login-date" defaultValue={selectedEmployee.lastLoginDate} disabled />
                        <label for="last-login-date">Last Login Date</label>
                    </div>

                    <div className="lbl-wrap-x-more">
                        <input type="text" id="newuser-supervisor-name" name="newuser-supervisor-name" defaultValue={selectedEmployeeManagerName} disabled />
                        <label for="supervisor-name">Manager</label>
                    </div>

                    <div className="lbl-wrap-x-more">
                        <input type="text" id="edt-username" name="edt-username" defaultValue={selectedEmployee.webuserId} disabled  />
                        <label>Username</label>
                    </div>
                    <br /><br />

                    <h2>Entity Associations</h2>
                    <div id="entity-association">
                        <div className="lbl-wrap-x-more">
                            {/*
                            @{ var disabled2 = "";
                                EntityType selected_entity_type = EntityType.Null;

                                if (user.Entites[0].Type != EntityType.INTERNAL) {
                                    disabled2 = "disabled";
                                }
                                var selected_defaultValue = user.Entites[0].Id;
                            }
                            */}
                            <select id="entity" name="entity" onChange={() => {setEntityType(); enableAddUser();}} required disabled>
                                {entityOptions}
                            </select>
                            <input type="hidden" id="selected-entity" name="selected-entity" defaultValue="@selected_value" />
                            <label for="entity">Entity</label>
                        </div><br />

                        <div className="lbl-wrap-x-more">
                            <select id="entity_type" name="entity_type" onChange={setSelecteddefaultValue} disabled>
                                <option defaultValue="">-- SELECT ONE --</option>
                                {entityTypeOptions}
                            </select>
                            <label for="entity_type">Entity Type</label>
                        </div><br />
                        <input type="hidden" id="entity_type_selected" name="entity_type_selected" defaultValue="" onChange={enableAddUser} />

                        <div className="lbl-wrap-x-more">
                            <select id="role_code" name="role_code" onChange={enableAddUser} required>
                                <option value="">-- SELECT ONE --</option>
                                {roleTypeOption}
                            </select>
                            <label for="role_code">Role</label>
                        </div>
                    </div>

                    <div className="account-settings-row" id="admin-settings-button-row">
                        <input type="button" className="fake_button-sm" id="disable-account" name="disable-account" defaultValue="Delete" onClick="ManagerDeleteUser();" disabled={buttonRowDisabled} />
                        <input type="button" className="fake_button-sm-wide" id="reset-password" name="reset-password" defaultValue="Reset Password" onClick="ManagerResetPassword();" disabled={buttonRowDisabled} />
                        
                        <input type="reset" id="clear-new-user"name="clear-new-user" className="fake_button-sm" defaultValue="Clear" />
                        <input type="button" id="submit-new-user" name="submit-new-user" className="fake_button-sm" defaultValue="Save" onClick="AddUpdateEmployeeAccount();" disabled={buttonRowDisabled} />
                    </div>

                </div>
            </div>

            <div className="shadow-panel-lg" id="admin-user-accounts">
                <h2 className="shadow-title" >User Accounts</h2>
                <div className="shadow-talk-modal">
                    <label className="warning" id="account-edit-instruction">double click the username to edit the account</label>
                    
                        {/* <!-- populated on selecting button in table below --> */}
                        <input type="hidden" id="selected-username" name="selected-username" defaultValue="" />
                        <input type="hidden" id="selected-email" name="selected-email" defaultValue="" />
                        
                        <table id="direct-reports">
                                <tr>
                                    <th className="direct-reports-username">username</th>
                                    <th className="direct-reports-firstname">full name</th>
                                </tr>
                                    {user.directReportEmployees?.map(e =>  {
                                    const fullname = e.lastName + ", " + e.firstName;
                                    return(
                                        <>
                                        <tr className="direct-reports-row">
                                            <td className="direct-reports-username" name="direct-reports-username" id="direct-reports-username" onDoubleClick={() => {getEmployeeInformation(e.webuserId)}} >{e.webuserId}</td>
                                            <td className="direct-reports-firstname" name="direct-reports-firstname" id="direct-reports-firstname">{fullname}</td>
                                        </tr>
                                        </>
                                        )
                                    })}    
                        </table>
                </div>
            </div>
        </>

    );
}

export default EmployeeAccountViewPanel;